module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/root//harvest-left.png?v=b7d981de";